/*eslint-disable*/

function headingHeight() {
  var el = $('.typewriter h2')
  el.each(function () {
    var h = $(this).outerHeight()
    $(this).css('height', h).empty()
  })
}

function isScrolledIntoView(elem) {
  var $elem = $(elem)
  var $window = $(window)

  var docViewTop = $window.scrollTop()
  var docViewBottom = docViewTop + $window.height()

  var elemTop = $elem.offset().top
  var elemBottom = elemTop + $elem.height()

  return elemBottom <= docViewBottom && elemTop >= docViewTop
}

var TxtRotate = function (el, toRotate, period) {
  this.toRotate = toRotate
  this.el = el
  this.loopNum = 0
  this.period = parseInt(period, 40) || 4000
  this.txt = ''
  this.tick()
  this.isDeleting = false
}

TxtRotate.prototype.tick = function () {
  var i = this.loopNum % this.toRotate.length
  var fullTxt = this.toRotate[i]

  if (this.isDeleting) {
    this.txt = fullTxt.substring(0, this.txt.length - 1)
  } else {
    this.txt = fullTxt.substring(0, this.txt.length + 1)
  }

  this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>'

  var that = this
  var delta = 300 - Math.random() * 500

  if (this.isDeleting) {
    delta /= 2
  }

  if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period
    this.isDeleting = true
  } else if (this.isDeleting && this.txt === '') {
    this.isDeleting = false
    this.loopNum++
    delta = 500
  }

  setTimeout(function () {
    that.tick()
  }, delta)
}

window.onload = function () {
  var elements = document.getElementsByClassName('txt-rotate')
  for (var i = 0; i < elements.length; i++) {
    var toRotate = elements[i].getAttribute('data-rotate')
    var period = elements[i].getAttribute('data-period')
    if (toRotate) {
      new TxtRotate(elements[i], JSON.parse(toRotate), period)
    }
  }
  // INJECT CSS
  var css = document.createElement('style')
  css.type = 'text/css'
  document.body.appendChild(css)
}

$(document).ready(function () {
  headingHeight()

  $('.txt-rotate').each(function () {
    if (isScrolledIntoView($(this))) {
      $(this).addClass('visible')
    }
  })
})

$(window).scroll(function () {
  $('.txt-rotate').each(function () {
    if (isScrolledIntoView($(this))) {
      $(this).addClass('visible')
    }
  })
})
/*eslint-enable*/
